
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Booking from "../../../domain/booking/Booking";
import Room from "@/domain/restaurant/Room";
import Table from "@/domain/restaurant/Table";
import UtilService from "@/services/UtilService";
import DialogBanner from "@/components/app/DialogBanner.vue";
import BookingsByTableCard from "@/components/booking/bookingsByTable/BookingsByTableCard.vue";
import Restaurant from "@/domain/restaurant/Restaurant";
@Component({
  components: { BookingsByTableCard, DialogBanner }
})
export default class BookingsByTableDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: () => [] })
  bookings!: Booking[];

  @Prop({ default: null })
  restaurant!: Restaurant | null;

  tables: { [key: number]: Table } = {};

  loading = false;

  currentTab = 0;

  mounted() {
    this.getTableDictionary();
    console.log("MOUNTED");
  }

  get roomList(): Room[] {
    if (this.restaurant != null && this.restaurant.rooms != null) {
      this.restaurant.rooms.sort(Room.RoomByNameAscendingComparator);
      for (let i = 0; i < this.restaurant.rooms.length; i++) {
        this.restaurant.rooms[i].tables.sort(
          Table.TablesByNameAscendingComparator
        );
      }
      return this.restaurant.rooms;
    }

    return [];
  }

  getBookingsByTable(table: Table) {
    const bookingsOnTable = [];
    if (table == null) return [];
    const affectedIds = new Set<number>(Table.getAllAffectedTableIds(table));
    for (let i = 0; i < this.bookings.length; i++) {
      if (
        Booking.getStatusActive(this.bookings[i].status) &&
        this.bookings[i].tableId !== undefined &&
        affectedIds.has(this.bookings[i].tableId as number)
      )
        bookingsOnTable.push(this.bookings[i]);
    }
    bookingsOnTable.sort(Booking.sortBookingByTime);
    return bookingsOnTable;
  }

  getTableFromId(tableId: number) {
    if (this.tables[tableId] != null) return this.tables[tableId];
    return new Table();
  }

  get dialog() {
    return this.value;
  }

  set dialog(newVal: boolean) {
    this.$emit("input", newVal);
  }

  @Watch("restaurant")
  async getTableDictionary() {
    const rest = this.restaurant;
    if (rest != null) this.tables = UtilService.getTableDict(rest);
    else this.tables = {};
  }
}
